import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Message {
  id: string;
  content: string;
  senderType: 'user' | 'bot' | 'system';
  timestamp: number;
  status: 'sending' | 'sent' | 'delivered' | 'read' | 'error';
  type: 'text' | 'image' | 'file' | 'audio' | 'location' | 'sticker';
  metadata?: Record<string, any>;
}

export const useMessageStore = defineStore('messages', () => {
  const messages = ref<Message[]>([]);
  const loading = ref(false);

  function addMessage(message: Message) {
    messages.value.push(message);
  }

  function updateMessageStatus(messageId: string, status: Message['status']) {
    const message = messages.value.find(m => m.id === messageId);
    if (message) {
      message.status = status;
    }
  }

  function updateMessage(messageId: string, updates: Partial<Message>) {
    const messageIndex = messages.value.findIndex(m => m.id === messageId);
    if (messageIndex !== -1) {
      messages.value[messageIndex] = { ...messages.value[messageIndex], ...updates };
    }
  }

  function setLoading(value: boolean) {
    loading.value = value;
  }

  function clearMessages() {
    messages.value = [];
  }

  function addSystemMessage(content: string) {
    addMessage({
      id: `system-${Date.now()}`,
      content,
      senderType: 'system',
      timestamp: Date.now(),
      status: 'sent',
      type: 'text'
    });
  }

  return {
    messages,
    loading,
    addMessage,
    updateMessageStatus,
    updateMessage,
    setLoading,
    clearMessages,
    addSystemMessage,
  };
});

export type MessageStore = ReturnType<typeof useMessageStore>; 